import { gql } from "@apollo/client";

export const GET_JUSTIFICACION_MOTIVO = gql`
    query getJustificacionMotivo($area: String!, 
                               $estado: String!){
        justificacionMotivo( area: $area,
                           estado: $estado)
        {
            idMotivoJustificacion
            descripcionCorta
            descripcionLarga
        }
 }
`;